import { Component,
	OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Event, NavigationEnd, Router } from '@angular/router';
import { QuoteSessionQuery } from '@app/store/session/session.query';
import {
	AB_153_PAGE_ONE_ENHANCED_CONTENT,
	VARIATION_ON,
} from '@constants/kameleoon';
import { ROUTES } from '@constants/routes';
import { KameleoonService } from '@services/kameleoon.service';
import { LoggingService } from '@services/logging.service';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

declare global {
	interface Window {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		ketch: any;
	}
}

@Component({
	selector: 'qe-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
	public footerLogoSrc: string = 'assets/logos/embrace-pet-insurance.png';
	public copyrightYear: number = new Date().getFullYear();
	public version: string = environment.version.split('.')?.[0];
	public isSelectedPolicy = false;
	public privacyPolicyUrl: string;
	public embracePolicyUrl: string;
	public showEnhancedContent: boolean = false;

	constructor(
		private readonly router: Router,
		private readonly dialog: MatDialog,
		private readonly kameleoonService: KameleoonService,
		private readonly loggingService: LoggingService,
		private readonly sessionQuery: QuoteSessionQuery,
	) {
		this.privacyPolicyUrl = environment.privacyPolicyUrl;
		this.embracePolicyUrl = environment.embracePolicyUrl;
		this.router.events.subscribe((event: Event) => {
			if (event instanceof NavigationEnd) {
				this.isSelectedPolicy = event.url.includes(ROUTES.SELECT_A_POLICY);
			}
		});
	}

	async ngOnInit(): Promise<void> {
		const brand = await firstValueFrom(this.sessionQuery.brand$());

		await this.kameleoonService.initializeClient(brand.toLowerCase());

		this.showEnhancedContent = this.kameleoonService.getActiveFeatureFlagDetails(AB_153_PAGE_ONE_ENHANCED_CONTENT) === VARIATION_ON;
	}

	public openPrivacyPolicyModal(ev: UIEvent): void {
		ev.preventDefault();
		import(`@shared/privacy-policy-modal/privacy-policy-modal.component`)
			.then((c) => this.dialog.open(c.PrivacyPolicyModalComponent))
			.catch((err) => this.loggingService.error(err));
	}

	public openEmbracePrivacySettings(ev: UIEvent): void {
		ev.preventDefault();
		if (window.ketch)
		{
			window.ketch('showPreferences');
		}
	}
}
